import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        width: 'auto' as 'auto',
        marginTop: '1rem'
    },
    pageButtonContainer: { marginRight: '1rem' },
    caretIcon: {
        height: '6px',
        width: '6px'
    },
    pageButton: {
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#cfcfcf'}`,
        borderRadius: '4px',
        width: 'fit-content' as 'fit-content',
        minWidth: '1.5rem',
        height: '1.5rem',
        padding: '0 .25rem',
        margin: '0 .15rem',
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        '&:first-child': { marginLeft: 0 },
        '&:last-child': { marginRight: 0 }
    },
    pageSelected: {
        backgroundColor: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        color: theme?.app?.applicationColors.enumColors.white || '#fff',
        '&:hover': { backgroundColor: theme?.app?.applicationColors.enumColors.greyLight || 'rgba(0, 0, 0, 0.3)' }
    },
    goToContainer: { width: 'auto' as 'auto' },
    goToLabel: {
        alignSelf: 'center' as 'center',
        paddingRight: '.75rem'
    },
    goToInput: { width: '5rem' },
    input: { textAlign: 'center' as 'center' },
    applyButton: {
        marginLeft: '.75rem',
        height: '1.8rem'
    }
}));

export default muiStyles;